import { render } from "./LaChorale.vue?vue&type=template&id=fc0f31a4&scoped=true&ts=true"
import script from "./LaChorale.vue?vue&type=script&lang=ts"
export * from "./LaChorale.vue?vue&type=script&lang=ts"

import "./LaChorale.vue?vue&type=style&index=0&id=fc0f31a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0f31a4"]])

export default __exports__